import React, {Component} from 'react';
import _ from 'lodash';

import JqDatePicker from '../../lib/mxjslib/mx.react.jquery-ui.datepicker.min';

import {Time} from '../../util';



class DatePickerSingle extends Component {

  componentDidMount(){
    const {defaultDate = Time.getToday()} = this.props;
    JqDatePicker.func('setDate', defaultDate);
  }

  calendarOption(){
    const {onSelect} = this.props;

    const options = {
      inline: true,
      yearSuffix: ' -',
      domType: 'input',
      dateFormat: 'yy-mm-dd',
      dayNames: ['일', '월', '화', '수', '목', '금', '토'],
      dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
      dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
      monthNames: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      monthNamesShort: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      showMonthAfterYear: true,
    
      onSelect: (dateText) => {
        if(onSelect) onSelect(dateText);
      }
    };
    return options;
  }


  render() {
    return (
      <JqDatePicker {...this.calendarOption()} />
    );
  }
}

export default DatePickerSingle;


// WEBPACK FOOTER //
// ./src/components/datepicker/single.js